import React, { useState } from 'react'
import { useTranslation } from '../../../../common/hooks/helper/useTranslation'
import { BetmenListFilter } from '../../../../common/components'
import { BooleanFilter } from '../../../../common/components/Filters/BooleanFilter'
import { DoctorPatientProfile } from '../types/doctorPatients.types'
import { ReferralList } from './PatientReferrals/ReferralList'
import {
  getStatusesByReferralStatusFilter,
  ReferralsFilterForDoctor,
} from './PatientReferrals/referralStatusFilterForDoctors'
import { usePatientReferralCount } from '../hooks/usePatientReferralCount'

type Props = {
  patientProfile: DoctorPatientProfile
}

const PatientReferrals: React.FC<React.PropsWithChildren<Props>> = ({
  patientProfile,
}) => {
  const { t } = useTranslation()

  const [filterInput, setFilterInput] = useState<ReferralsFilterForDoctor>({
    searchTerm: '',
    isExisting: true,
  })

  const filterData = {
    searchTerm: filterInput.searchTerm,
    onlyOwn: filterInput.onlyOwn,
    statuses: getStatusesByReferralStatusFilter(filterInput),
  }

  const { total: totalExisting, refetch: refetchExisting } =
    usePatientReferralCount({
      patientId: patientProfile.id,
      statuses: getStatusesByReferralStatusFilter({ isExisting: true }),
    })
  const { total: totalDeleted, refetch: refetchDeleted } =
    usePatientReferralCount({
      patientId: patientProfile.id,
      statuses: getStatusesByReferralStatusFilter({ isDeleted: true }),
    })

  return (
    <ReferralList
      patientProfile={patientProfile}
      filters={
        <>
          <BetmenListFilter
            searchTerm={filterInput.searchTerm}
            handleSearch={(searchTerm) => {
              setFilterInput((prevFilter) => ({
                ...prevFilter,
                searchTerm: searchTerm ?? '',
              }))
            }}
          />
          <BooleanFilter
            filterInput={!!filterInput.onlyOwn}
            setFilterInput={(newFilter: boolean) =>
              setFilterInput((prevInput) => ({
                ...prevInput,
                onlyOwn: newFilter,
              }))
            }
            label={t('survey:question.filter.own')}
          />

          <BooleanFilter
            filterInput={!!filterInput.isExisting}
            setFilterInput={(newFilter: boolean) =>
              setFilterInput((prevInput) => ({
                ...prevInput,
                isExisting: newFilter,
              }))
            }
            label={`${t('patients:referral.filter.isExisting')} (${totalExisting})`}
          />
          <BooleanFilter
            filterInput={!!filterInput.isDeleted}
            setFilterInput={(newFilter: boolean) =>
              setFilterInput((prevInput) => ({
                ...prevInput,
                isDeleted: newFilter,
              }))
            }
            label={`${t('patients:referral.filter.isDeleted')} (${totalDeleted})`}
          />
        </>
      }
      filterData={filterData}
      refetchCount={() => {
        refetchDeleted()
        refetchExisting()
      }}
    />
  )
}

export { PatientReferrals }
